module.exports = __webpack_public_path__ + "static/videogameworld-e7d4c998500c048c9d45bf6795f34c89.svg";